import React from "react";

export default function LoteSummary({ progress, costs, regressions, observacoes }) {
  return (
    <>
      {/* Progress Bar */}
      <div className="space-y-1 mb-4">
        <div className="flex justify-between text-xs font-bold text-slate-600">
          <span>Progresso</span>
          <span>{progress.percent}%</span>
        </div>
        <div className="w-full bg-slate-100 rounded-full h-2">
          <div 
            className="bg-purple-600 h-2 rounded-full transition-all duration-500" 
            style={{ width: `${progress.percent}%` }}
          ></div>
        </div>
        <div className="flex justify-between items-center text-[10px] font-bold text-slate-500">
          <span>
            {progress.concluidas} de {progress.total} peças ({progress.concluidas} concluídas)
          </span>
          <div className="flex items-center gap-1.5">
            {progress.interceptadas > 0 && (
              <span className="text-amber-700 bg-amber-50 px-2 py-0.5 rounded border border-amber-200 font-extrabold">
                {progress.interceptadas} interceptada{progress.interceptadas !== 1 ? "s" : ""}
              </span>
            )}
            {progress.suspensas > 0 && (
              <span className="text-red-700 bg-red-50 px-2 py-0.5 rounded border border-red-200 font-extrabold">
                {progress.suspensas} suspensa{progress.suspensas !== 1 ? "s" : ""}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Info Grid */}
      <div className="grid grid-cols-2 gap-3 bg-slate-50 p-3 rounded-lg text-xs mb-3">
        <div>
          <span className="text-[10px] text-slate-400 block font-bold uppercase">Custo BOM Efetivo</span>
          <span className="font-extrabold text-slate-700">R$ {costs.effective.toFixed(2)}</span>
          <span className="text-[9px] text-slate-400 block">Previsto: R$ {costs.expected.toFixed(2)}</span>
        </div>
        <div>
          <span className="text-[10px] text-slate-400 block font-bold uppercase">Erros / Regressões</span>
          <span className={`font-extrabold flex items-center gap-1 ${regressions.total > 0 ? "text-red-600" : "text-emerald-600"}`}>
            {regressions.total} regressões
          </span>
        </div>
      </div>

      {/* Tabela de Insumos BOM (S2.1) */}
      {costs.suppliesReport && costs.suppliesReport.length > 0 && (
        <div className="bg-slate-50/80 border border-slate-200 rounded-xl p-3 space-y-2 mb-3">
          <div className="flex justify-between items-center border-b border-slate-200 pb-1.5">
            <span className="text-[10px] font-black text-slate-700 uppercase tracking-wider flex items-center gap-1">
              💎 Insumos BOM (Previsto × Efetivo)
            </span>
            <span className="text-[10px] font-bold text-purple-700">
              {costs.suppliesReport.length} insumo{costs.suppliesReport.length !== 1 ? "s" : ""}
            </span>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-left text-[10px]">
              <thead>
                <tr className="border-b border-slate-200 text-slate-400 font-bold uppercase text-[8px]">
                  <th className="py-1">Insumo</th>
                  <th className="py-1 text-center">Previsto</th>
                  <th className="py-1 text-center">Efetivo</th>
                  <th className="py-1 text-right">Custo</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {costs.suppliesReport.map((ins, idx) => (
                  <tr key={idx} className="text-slate-700 font-medium">
                    <td className="py-1 font-bold truncate max-w-[120px]">{ins.nome}</td>
                    <td className="py-1 text-center text-slate-500 font-mono">{ins.qtdPrevista} {ins.unidade || "un"}</td>
                    <td className="py-1 text-center text-purple-700 font-bold font-mono">{ins.qtdEfetiva} {ins.unidade || "un"}</td>
                    <td className="py-1 text-right font-bold text-emerald-700">
                      {ins.custoTotal > 0 ? `R$ ${ins.custoTotal.toFixed(2)}` : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {observacoes && (
        <p className="text-[11px] text-slate-400 truncate mb-3">Obs: {observacoes}</p>
      )}
    </>
  );
}
